var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('div',{staticClass:"footer"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }